import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { configureTranslationProductName } from "@chams-pay/contracts";
import "@chams-pay/design-system/globals.css";
import "../../../packages/design-system/src/components.css";
import "./styles.css";
import { App } from "./App.js";
import { AppErrorBoundary, reportReactError } from "./core/app-error-boundary.js";
import { registerOfflineShell } from "./register-offline-shell.js";
import { applyDeploymentBranding, deploymentProductName } from "./core/deployment.js";

applyDeploymentBranding();
configureTranslationProductName(deploymentProductName);

const root = document.querySelector<HTMLDivElement>("#root");
if (!root) throw new Error("Missing application root");

createRoot(root, {
  onCaughtError: (error, errorInfo) => reportReactError("caught", error, errorInfo.componentStack),
  onRecoverableError: (error, errorInfo) =>
    reportReactError("recoverable", error, errorInfo.componentStack),
  onUncaughtError: (error, errorInfo) =>
    reportReactError("uncaught", error, errorInfo.componentStack),
}).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);

void registerOfflineShell();
